module.exports = [require("./Continental.js"), require("./EasterIsland.js")];